import type {ItemModelType} from "@stores/WorkspaceStore";
import {GetCollabDocResponse} from "@stores/serverConnection/types";
import {
    getDocumentAndUpdateLocalState
} from "@stores/document/DocumentLocal";
import {WsServerConnection} from "@stores/serverConnection/wsServerConnection";


export const getDocumentInfo = async (wsServerConnection: WsServerConnection, itemMST: ItemModelType): Promise<GetCollabDocResponse> => {
    const requestAbortController = new AbortController();
    return await getDocumentAndUpdateLocalState(wsServerConnection, itemMST.id, requestAbortController);
}
